import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  children: React.ReactNode;
  whiteBackground?: boolean;
  sectionPadding?: boolean;
  className?: string;
}
const FusionSection = ({ children, className, sectionPadding, whiteBackground }: Props) => {
  return (
    <div
      className={classnames(
        className,
        { bg: whiteBackground },
        styles.fusionSection,
        sectionPadding && styles.fusionSectionPadding,
      )}
    >
      {children}
    </div>
  );
};

FusionSection.defaultProps = {
  sectionPadding: true,
};

export default FusionSection;
